import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import SEO from '../components/seo/SEO'
import ServiceCard from '../components/ui/ServiceCard'
import { SERVICES } from '../data/services'
import styles from './Services.module.css'

export default function Services() {
  const { t } = useTranslation('services')
  const { t: tSeo } = useTranslation('seo')

  return (
    <div className={styles.page}>
      <SEO title={tSeo('services.title')} description={tSeo('services.description')} canonical="/services" />

      <section className={styles.hero}>
        <div className={styles.container}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="eyebrow">{t('hero.eyebrow')}</span>
            <h1>{t('hero.title')}</h1>
            <p className={styles.lead}>{t('hero.lead')}</p>
          </motion.div>
        </div>
      </section>

      <section className={styles.services}>
        <div className={styles.container}>
          <div className={styles.grid}>
            {SERVICES.map((service, i) => (
              <motion.div
                key={service.slug}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.05 }}
              >
                <ServiceCard
                  title={t(`items.${service.slug}.title`)}
                  description={t(`items.${service.slug}.description`)}
                  icon={service.icon}
                  slug={service.slug}
                />
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}
